import { coordinatesToPoint } from '@curbnturf/helpers';
import { Point } from 'geojson';
import { ICoordinateGis } from '../interfaces';
import { LatLon } from './coordinates';

const earthRadius = 3959; // radius of earth in miles

export class CoordinateGis extends LatLon implements ICoordinateGis {
  location?: Point;

  constructor(data?: ICoordinateGis) {
    super(data);

    if (data) {
      this.setData(data);
    }
  }

  override setData(data: ICoordinateGis): void {
    super.setData(data);
    this.location = coordinatesToPoint(data);
  }
}
